import { render } from "./i-file.vue?vue&type=template&id=4154dcc0"
import script from "./i-file.vue?vue&type=script&lang=js"
export * from "./i-file.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__